const LOCALE = 'nl-NL';

/**
 * Format a price to a localized string prepended with a € symbol.
 *
 * @param {(string|number)} value
 * @returns {string}
 */
export const formatPriceValue = value => {
    if (typeof value === 'undefined') {
        return '';
    }

    if (typeof value === 'string') {
        value = Number(value);
    }

    return `€ ${value.toLocaleString(LOCALE)}`;
};

/**
 * Format a distance vale to a localized string appended with km.
 *
 * @param {(string|number)} value
 * @returns {string}
 */
export const formatMileageValue = value => {
    if (typeof value === 'undefined') {
        return '';
    }

    if (typeof value === 'string') {
        value = Number(value);
    }

    return `${value.toLocaleString(LOCALE)} km`;
};
